// extracted by mini-css-extract-plugin
export default {"teamListContainer":"team-list_styles_teamListContainer__htI9V","selectContainer":"team-list_styles_selectContainer__k6kDK"};